import React from 'react'
import propTypeSchema from 'react-json-schema-proptypes'
import { Typography } from '../types'
import { markdown, valueOrUndefined } from '../common'
import Radium, { Style } from 'radium'

const schema = {
  'type': 'object',
  'properties': {
    'firstText': { 'type': 'string' },
    'firstTextStyle': Typography.Schema,
    'secondText': { 'type': 'string' },
    'secondTextStyle': Typography.Schema,
    'thirdText': { 'type': 'string' },
    'thirdTextStyle': Typography.Schema,
    'logosCount': { 'type': 'number' },
    'logosHeight': { 'type': 'string' },
    'logosMarginTop': { 'type': 'string' },
    'bulletsMarginBottom': {'type': 'string'},
    'bulletsLineHeight': {'type': 'string'},
    'luMarginBottom': {'type': 'string'},
    'pMarginBottom': {'type': 'string'},
  }
}

const imageName = 'sideBar-logo'

@Radium
export default class DeltaSidebar extends React.PureComponent {
  static propSchema = schema
  static propTypes = propTypeSchema(schema, {
    'required': ['assetLoader'],
    'properties': {
      'assetLoader': { 'isFunction': true }
    }
  })
  static defaultProps = {
    logosCount: 0,
    bulletsMarginBottom: '30px',
    bulletsLineHeight: '1',
    pMarginBottom: '30px',
    luMarginBottom: '30px',
    firstTextStyle: {
      color: '#000000'
    },
    secondTextStyle: {
      color: '#000000'
    },
    thirdTextStyle: {
      color: '#000000'
    },
  }

  render () {
    const styles = {
      first: valueOrUndefined(this.props, 'firstTextStyle'),
      second: valueOrUndefined(this.props, 'secondTextStyle'),
      third: valueOrUndefined(this.props, 'thirdTextStyle'),
      logos: {
        height: valueOrUndefined(this.props, 'logosHeight'), 
        marginTop: valueOrUndefined(this.props, 'logosMarginTop')
      },
      bulletsMarginBottom: valueOrUndefined(this.props, 'bulletsMarginBottom'),
      bulletsLineHeight: valueOrUndefined(this.props, 'bulletsLineHeight'),
      luMarginBottom: valueOrUndefined(this.props, 'luMarginBottom'),
      pMarginBottom: valueOrUndefined(this.props, 'pMarginBottom'),
    }

    let sideBarImages = []
    for (let i = 0; i < this.props.logosCount; i++) {
      sideBarImages.push(
        <div key={i} className={'sideBarImage'} style={[{backgroundImage: `url(${this.props.assetLoader(`${imageName}${i}.png`)})`}, styles.logos]} />
      )
    }
    return <div className={'delta'}>
      <div className={'rightText'}>
        <Style
          scopeSelector=".rightText"
          rules={{
            lu: {
              marginBottom: styles.luMarginBottom
            },
            li: {
              marginBottom: this.props.bulletsMarginBottom,
              lineHeight: styles.bulletsLineHeight,
            },
            p: {
              marginBottom: styles.pMarginBottom
            },
            '.first strong': {
              color: styles.first.color
            },
            '.second strong': {
              color: styles.second.color
            },
            '.third strong': {
              color: styles.third.color
            }
          }}
        />
      <span className={'first'} style={[styles.first]}>
        {markdown(this.props.firstText)}
      </span>
        <span className={'second'} style={[styles.second]}>
        {markdown(this.props.secondText)}
      </span>
        <span className={'third'} style={[styles.third]}>
        {markdown(this.props.thirdText)}
      </span>
        {sideBarImages}
      </div>
    </div>
  }
}
